import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/ui-keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0


import { BehaviorSubject } from '@polkadot/x-rxjs';
import { createOptionItem } from "../options/item.mjs";
import { env } from "./env.mjs";

function callNext(current, subject, withTest) {
  var isDevMode = env.isDevelopment();
  var filtered = {};
  Object.keys(current).forEach(function (key) {
    var _current$key$json = current[key].json;
    _current$key$json = _current$key$json === void 0 ? {} : _current$key$json;
    var _current$key$json$met = _current$key$json.meta;
    _current$key$json$met = _current$key$json$met === void 0 ? {} : _current$key$json$met;
    var _current$key$json$met2 = _current$key$json$met.isTesting,
        isTesting = _current$key$json$met2 === void 0 ? false : _current$key$json$met2;

    if (!withTest || isDevMode || isTesting !== true) {
      filtered[key] = current[key];
    }
  });
  subject.next(filtered);
}

export function genericSubject(keyCreator) {
  var withTest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var current = {};
  var subject = new BehaviorSubject({});

  var next = function next() {
    return callNext(current, subject, withTest);
  };

  env.subject.subscribe(next);
  return {
    add: function add(store, address, json, type) {
      current = _objectSpread({}, current);
      current[address] = {
        json: _objectSpread(_objectSpread({}, json), {}, {
          address: address
        }),
        option: createOptionItem(address, json.meta.name),
        type: type
      }; // we do not store dev or injected accounts (external/transient)

      if (!json.meta.isInjected && (!json.meta.isTesting || env.isDevelopment())) {
        store.set(keyCreator(address), json);
      }

      next();
      return current[address];
    },
    remove: function remove(store, address) {
      current = _objectSpread({}, current);
      delete current[address];
      store.remove(keyCreator(address));
      next();
    },
    subject: subject
  };
}